import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import _ from "lodash";
import moment from "moment";

import AdminTable from "../../../../components/common/table/AdminTable";
import AdvancedSearch from "../components/advancedSearch/Filters";
import { TableExportButton } from "../../../../components/common/table/TableExportButton";
import TableOptions from "../../../../components/common/table/TableOptions";
import Filters from "./Filters";
import styles from "./Companies.scss";

import parseAdvancedSearch from "../../../../utils/parseAdvancedSearch";
import parseFilters from "../../../../utils/parseFilters";
import {
  encodeSearchParams,
  getFinalQueryString,
  getPageQueryString
} from "../../../../utils/parseQueries";
import parseSortData from "../../../../utils/parseSortData";

const tableColumns = [
  {
    headerText: "COMPANY NAME",
    accessor: "company_name",
    sortable: true
  },
  {
    headerText: "HIRING MANAGER",
    accessor: "hiring_manager",
    sortable: true
  },
  {
    headerText: "EMAIL",
    accessor: "email",
    sortable: true
  },
  {
    headerText: "LOCATION",
    accessor: "location",
    sortable: false
  },
  {
    headerText: "INDUSTRY",
    accessor: "industry",
    sortable: false
  },
  {
    headerText: "SIZE",
    accessor: "company_size",
    sortable: false
  },
  {
    headerText: "DATE CREATED",
    accessor: "created_at",
    sortable: true
  },
  {
    headerText: "LAST LOGIN",
    accessor: "last_login_date",
    sortable: true
  },
  {
    headerText: "# OF JOBS POSTED",
    accessor: "projects_posted",
    sortable: true
  },
  {
    headerText: "# OF SOWS",
    accessor: "projects_sow",
    sortable: true
  }
];

class Companies extends Component {
  constructor(props) {
    super(props);

    this.state = {
      advancedSearch: props.advancedSearch || [],
      filters: props.filters || [],
      currentPage: props.page || 1,
      showAdvancedSearch: false,
      showFilters: false
    };

    this.handleSubmitAdvancedSearch = this.handleSubmitAdvancedSearch.bind(
      this
    );
    this.handleSubmitFilters = this.handleSubmitFilters.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onSortChange = this.onSortChange.bind(this);
    this.openAdvancedSearch = this.openAdvancedSearch.bind(this);
    this.openFilters = this.openFilters.bind(this);
  }

  handleSubmitAdvancedSearch(data) {
    const advancedSearch = parseAdvancedSearch(data.filters);
    const filters = parseFilters(this.state.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "companies", pageNumber: 1 });
    this.props.setSort({ table: "companies", sortData: null });

    this.setState({ advancedSearch: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(data.filters, this.state.filters)
    });
  }

  handleSubmitFilters(data) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(data.filters);
    const finalQueryString = getFinalQueryString(filters + advancedSearch);

    this.props.getTable(finalQueryString);
    this.props.getCsvData(filters + advancedSearch);
    this.props.setPage({ table: "companies", pageNumber: 1 });
    this.props.setSort({ table: "companies", sortData: null });

    this.setState({ filters: data.filters, currentPage: 1 });

    this.props.history.push({
      ...this.props.location,
      search: encodeSearchParams(this.state.advancedSearch, data.filters)
    });
  }

  onPageChange(pageIndex) {
    window.scrollTo(0, 0);

    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(this.props.sortData);
    const pageQuery = getPageQueryString(pageIndex);
    const finalQueryString = getFinalQueryString(
      pageQuery + filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "companies", pageNumber: pageIndex + 1 });

    this.setState({ currentPage: pageIndex + 1 });
  }

  onSortChange(sortData) {
    const advancedSearch = parseAdvancedSearch(this.state.advancedSearch);
    const filters = parseFilters(this.state.filters);
    const sort = parseSortData(sortData);
    const finalQueryString = getFinalQueryString(
      filters + advancedSearch + sort
    );

    this.props.getTable(finalQueryString);
    this.props.setPage({ table: "companies", pageNumber: 1 });
    this.props.setSort({ table: "companies", sortData });

    this.setState({ currentPage: 1 });
  }

  openAdvancedSearch() {
    this.setState({ showAdvancedSearch: true });
  }

  openFilters() {
    this.setState({ showFilters: true });
  }

  getCompanyName(company) {
    const fullCompanyData = _.get(company, "profile.company");

    return fullCompanyData ? (
      <Link to={`/admin/company/${fullCompanyData.id}`}>
        {fullCompanyData.name}
      </Link>
    ) : null;
  }

  getTableData(target) {
    const companies =
      target === "csv" ? this.props.companies_csv : this.props.companies;

    let data = companies.map(company => {
      const fullCompanyData = _.get(company, "profile.company") || {};

      return {
        id: company.id,
        company_name: this.getCompanyName(company),
        hiring_manager: `${company.first_name} ${company.last_name}`,
        email: _.get(company, "email"),
        created_at: moment(_.get(fullCompanyData, "created_at")).format(
          "M/DD/YYYY"
        ),
        location: _.get(fullCompanyData, "location"),
        industry: _.get(company, "profile.company.industry.value"),
        company_size: _.get(company, "profile.company.company_size.value"),
        industry_id: _.get(company, "profile.company.industry_id"),
        company_size_id: _.get(company, "profile.company.company_size_id"),
        last_login_date: moment(company.last_login_at).format("M/DD/YYYY"),
        projects_posted: _.get(company, "statistics.posted"),
        projects_sow: _.get(company, "statistics.sow")
      };
    });

    return data;
  }

  render() {
    return (
      <div>
        <AdvancedSearch
          show={this.state.showAdvancedSearch}
          onClose={() => this.setState({ showAdvancedSearch: false })}
          onSubmit={this.handleSubmitAdvancedSearch}
        />
        <Filters
          show={this.state.showFilters}
          onClose={() => this.setState({ showFilters: false })}
          onSubmit={this.handleSubmitFilters}
        />
        <TableOptions
          title="Companies / All"
          paginationCount={this.props.paginationCount}
          onFilterClick={this.openFilters}
          filtersNumber={this.state.filters && this.state.filters.length}
          searchsNumber={
            this.state.advancedSearch && this.state.advancedSearch.length
          }
          tableColumns={tableColumns}
          onSearchClick={this.openAdvancedSearch}
        />
        <div className={styles.companies}>
          <AdminTable
            page={this.state.currentPage - 1}
            tableData={this.getTableData()}
            tableColumns={tableColumns}
            loading={this.props.loading}
            selectable={false}
            numberOfPages={this.props.numberOfPages}
            onPageChange={this.onPageChange}
            noRowsText="No Companies found"
            sortData={this.props.sortData}
            onSortChange={this.onSortChange}
            style={{
              height: "640px" // This will force the table body to overflow and scroll
            }}
          />
        </div>
        <Col
          lg={2}
          md={2}
          sm={2}
          style={{ textAlign: "center", paddingTop: "1.5em" }}
        >
          <TableExportButton
            tableColumns={tableColumns}
            tableData={this.getTableData("csv")}
          />
        </Col>
      </div>
    );
  }
}

export default Companies;



// WEBPACK FOOTER //
// ./src/routes/admin/companies/components/Companies.js